import './Header.css'
import nitLogo from '../assets/nitLogo.png'

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img src={nitLogo} alt="NIT Logo" className="nit-logo" />
        </div>
        <div className="header-center">
          <h1 className="header-title">ECM CGPA Tracker</h1>
          <p className="header-subtitle">
            Calculate your required SGPA to achieve your target CGPA
          </p>
        </div>
      </div>
    </header>
  )
}

export default Header
